import { Button, Label, TextInput } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useMutationData } from "../../../hooks/useMutationData";
import { Loading } from "../../../components/Loading/Loading";
import { useContext } from "react";
import { ThemeContext } from "../../../components/ThemeContext/ThemeContext";

export const EmpresasCrearScreen = () => {
  const { control, handleSubmit } = useForm(); // React Hook Form control
  const mutateEmpresa = useMutationData({ url: "/empresa" });
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext); // Accede al contexto del tema

  if (mutateEmpresa.isPending) {
    return <Loading />;
  }

  return (
    <div
      className={`min-h-screen p-6 ${
        isDarkMode ? "bg-gray-800 text-white" : "bg-white text-black"
      }`}
    >
      <div
        className={`max-w-4xl mx-auto p-6 rounded-lg shadow-lg space-y-6 ${
          isDarkMode ? "bg-gray-700" : "bg-white"
        }`}
      >
        <div
          className={`bg-gradient-to-r from-blue-400 to-blue-600 p-6 text-white rounded-t-lg`}
        >
          <h2 className="text-3xl font-bold text-center">
            Crear una nueva Empresa
          </h2>
        </div>
        <form
          onSubmit={handleSubmit((data) => {
            mutateEmpresa.mutate(
              {
                data: { ...data, estatus: 1 },
                tipo: "post",
              },
              {
                onSuccess: () => navigate("/empresas"),
              }
            );
          })}
          className="space-y-6"
        >
          <div className="space-y-2">
            <Label htmlFor="nombre" value="Nombre de la Empresa" />
            <Controller
              name="nombre"
              control={control}
              defaultValue=""
              rules={{
                required: "Se requiere un nombre",
                maxLength: {
                  value: 64,
                  message: "El nombre debe tener menos de 64 caracteres",
                },
              }}
              render={({ field, fieldState }) => (
                <TextInput
                  id="nombre"
                  placeholder="Nombre de la empresa..."
                  {...field}
                  color={fieldState.error ? "failure" : "default"}
                  helperText={fieldState.error?.message}
                  className={
                    isDarkMode
                      ? "bg-gray-700 text-black"
                      : "bg-white text-black"
                  }
                />
              )}
            />
          </div>

          <div className="pt-4 flex flex-row items-center justify-between gap-4">
            <Button
              type="button"
              className={`w-1/2 ${
                isDarkMode
                  ? "bg-red-700 hover:bg-red-800"
                  : "bg-red-600 hover:bg-red-700"
              } text-white`}
              onClick={() => navigate("/empresas")}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              className={`w-1/2 ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-600 hover:bg-blue-700"
              } text-white`}
            >
              Crear
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
